import { Button, ClassName, Label, Row, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import ConditionalContainer from 'components/foundation/ConditionalContainer/ConditionalContainer';
import useSlackCertificationAccess from 'containers/settings/integrations/vendors/slack/hooks/useSlackCertificationAccess';
import { useToastDispatch } from 'contexts/ToastContext';
import useOrganizationUiSettingsUpdate from 'hooks/models/organization/settings/hooks/useOrganizationUiSettingsUpdate';
import { t } from 'i18next';
import { FunctionComponent, useState } from 'react';

export interface ICertificationsEnableFormProps {
  onRequestSubmitted: () => void;
  className?: ClassName;
}

const CertificationsEnableForm: FunctionComponent<ICertificationsEnableFormProps> = (props) => {
  const { className, onRequestSubmitted } = props;
  const toastDispatch = useToastDispatch();
  const [showErrorTip, setShowErrorTip] = useState(false);
  const certificationsAccess = useSlackCertificationAccess();
  const updateUiSettings = useOrganizationUiSettingsUpdate();

  const classes = classNames('certifications-enable-form', className);

  const requestAccess = async () => {
    let requestSuccessful = false;
    try {
      const response = await certificationsAccess();
      requestSuccessful = response.status === 200;
    } catch (e) {
      requestSuccessful = false;
    }
    if (requestSuccessful) {
      updateUiSettings('requestedCertificationsAccess', true);
      onRequestSubmitted();
    } else {
      toastDispatch({
        type: 'OPEN',
        payload: { label: t('Failed to send request. Try again later.'), theme: Theme.DANGER },
      });
      setShowErrorTip(true);
    }
  };

  return (
    <div className={classes}>
      <Label className="mt-3 mb-2">{t('-Now Includes-')}</Label>
      {t('Certifications & Licenses')}
      <ul className="pl-4">
        <li>{t('Automated reminders before certifications expire')}</li>
        <li>{t('Employees upload licenses and credentials directly in the app')}</li>
        <li>
          {t('Supervisors see requirements instantly and uncertified workers are blocked from clocking into equipment')}
        </li>
        <li>{t('Dashboard visibility keeps admins on top of expired or nearly expired certifications')}</li>
      </ul>
      <Label className="mt-3 mb-2">{t('-Coming Soon-')}</Label>
      <ul className="pl-4">
        <li>{t('Resource Scheduling (Q4 2025)')}</li>
        <li>{t('Equipment Inspection Reports (Q1 2026)')}</li>
      </ul>
      <Label className="mt-7 mb-2">{t('How to Get Started')}</Label>
      <div className="content">
        {t(
          'Click the button below and a BusyBusy team member will connect with you to walk through Operations and answer your questions. If you decide to move forward, we’ll activate the Operations Module in your account so you can start using Certifications & Licenses right away.'
        )}
      </div>
      <Label className="mt-7 mb-2">{t('Pricing')}</Label>
      <div className="content">{t('Speak with our sales team for full pricing details.')}</div>
      <Row className="mt-9">
        <Button type="primary" onClick={requestAccess}>
          {t('Contact')}
        </Button>
      </Row>

      <ConditionalContainer condition={showErrorTip}>
        <br />
        {t('* If you have an ad blocker, disable it and try again.')}
      </ConditionalContainer>
    </div>
  );
};

export default CertificationsEnableForm;
